var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cog-input", class: { "is-read-only": _vm.readonly } },
    [
      _vm.readonly
        ? [_vm._v(_vm._s(_vm.textValue || " "))]
        : [
            _vm.chameleon || _vm.mobile
              ? _c(
                  "c-picker-native",
                  {
                    attrs: {
                      placeholder: _vm.placeholder,
                      "show-placeholder": !_vm.chameleon && !_vm.nativeTextValue
                    },
                    scopedSlots: _vm._u(
                      [
                        _vm.mobile
                          ? {
                              key: "icon",
                              fn: function() {
                                return [
                                  _c("i-clock", {
                                    class: {
                                      "cog-offscreen": _vm.dateTimeIconIsHidden
                                    }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          : null
                      ],
                      null,
                      true
                    )
                  },
                  [
                    _c(
                      "input",
                      _vm._b(
                        {
                          ref: "input",
                          staticClass: "el-input__inner",
                          attrs: { id: "cog-" + _vm.id, type: "time" },
                          domProps: { value: _vm.nativeTextValue },
                          on: { change: _vm.handleNativeChange }
                        },
                        "input",
                        _vm.$attrs,
                        false
                      )
                    )
                  ]
                )
              : _c("c-select", {
                  ref: "select",
                  attrs: {
                    id: `${_vm.id}`,
                    value: _vm.value,
                    options: _vm.options,
                    scope: _vm.scope,
                    placeholder: _vm.placeholder,
                    "allow-arrows-to-change-value":
                      _vm.allowArrowsToChangeValue,
                    "additional-popper-class": "cog-time-popper",
                    "allow-other": "",
                    filterable: true,
                    "filter-match": "beginning",
                    editable: true
                  },
                  on: {
                    change: _vm.handleChange,
                    "visible-change": _vm.handleSelectVisibleChange
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "suffix",
                      fn: function() {
                        return [_c("i-clock")]
                      },
                      proxy: true
                    }
                  ])
                })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }